module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "icon": "magnify"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("Search")])])], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "This is expanded",
      "expanded": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "button is-static"
  }, [_vm._v("@gmail.com")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-field', [_c('b-select', {
    attrs: {
      "placeholder": "Currency"
    }
  }, [_c('option', [_vm._v("$")]), _vm._v(" "), _c('option', [_vm._v("£")]), _vm._v(" "), _c('option', [_vm._v("€")])]), _vm._v(" "), _c('b-input', {
    attrs: {
      "type": "number",
      "placeholder": "0,00"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-success"
  }, [_vm._v("Transfer")])])], 1), _vm._v(" "), _c('b-field', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('b-icon', {
    attrs: {
      "icon": "format-bold"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('b-icon', {
    attrs: {
      "icon": "format-italic"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('b-icon', {
    attrs: {
      "icon": "format-underline"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('b-icon', {
    attrs: {
      "icon": "format-align-left"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('b-icon', {
    attrs: {
      "icon": "format-align-center"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button"
  }, [_c('b-icon', {
    attrs: {
      "icon": "format-align-right"
    }
  })], 1)]), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "icon": "magnify"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("\n                    Button\n                ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('b-dropdown', [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', [_vm._v("Something else")])], 1)], 1)]), _vm._v(" "), _c('b-field', [_c('p', {
    staticClass: "control"
  }, [_c('b-dropdown', [_c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Filters")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "open_issues"
    }
  }, [_vm._v("Open Issues and Pull Requests")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "your_issues"
    }
  }, [_vm._v("Your Issues")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "pull_requests"
    }
  }, [_vm._v("Your Pull Requests")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "everything"
    }
  }, [_vm._v("Everything")])], 1)], 1), _vm._v(" "), _c('b-input', {
    attrs: {
      "icon": "magnify",
      "type": "search",
      "placeholder": "Search..."
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25c76c35"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/field/examples/ExAddons.vue
// module id = 1076
// module chunks = 5 228